// import css
/* @ts-ignore */
import "./assets/index.css";
// import global components
import HeaderMobile from "./components/global/header-mobile";
import HeaderMegaMenu from "./components/global/mega-menu-desktop";
import HeaderSAYT from "./components/global/header-sayt";
import HeaderTransparentNav from "./components/global/header-transparent-nav";
import ScrollToHash from "./components/global/scroll-to-hash";
import GlobalModal from "./components/global/modal";
import SlickCarousel from "./components/global/slick-carousel";
import SlickCarouselThumbs from "./components/global/slick-carousel-thumbs";
import ScrollToNav from "./components/global/scroll-to-nav";
import OpenBlockRuntime from "./components/global/open-block-runtime";
// init globals
HeaderTransparentNav();
HeaderMobile();
HeaderMegaMenu();
HeaderSAYT();
ScrollToHash();
GlobalModal();
SlickCarousel();
SlickCarouselThumbs();
ScrollToNav();
OpenBlockRuntime();
// import block components
import HeroTabs from "./components/blocks/hero-tabs";
import HeroDyanamicTabs from "./components/blocks/hero-dyanamic-tabs";
import AccordionItem from "./components/blocks/accordion-item";
import MetricsGrid from "./components/blocks/metrics-grid";
import LogoCarousel from "./components/blocks/logo-carousel";
import ScrollToBlock from "./components/blocks/scroll-to-block";
import FloatingContent from "./components/blocks/floating-content";
import PersonalizedVideo from "./components/blocks/personalized-video";
import RoiCalculatorBlock from "./components/blocks/roi-calculator";
import ScrollToRichText from "./components/global/scroll-to-rich-text";
import ScrollImage from "./components/blocks/scroll-image";
import ParallaxScroll from "./components/global/parallax-scroll";
import AnimateHero from "./components/blocks/animate-hero";
import AnimateTabBtns from "./components/global/animate-tab-btns";
import LottieWeb from "./components/blocks/lottie-web";
import IframeFormResizer from "./components/global/iframe-form-resizer";
// init blocks
HeroTabs();
HeroDyanamicTabs();
AccordionItem();
MetricsGrid();
LogoCarousel();
ScrollToBlock();
FloatingContent();
PersonalizedVideo();
RoiCalculatorBlock();
ScrollToRichText();
ScrollImage();
ParallaxScroll();
AnimateHero();
AnimateTabBtns();
LottieWeb();
IframeFormResizer();
// import page components
import SearchPage from "./components/pages/search-page";
import ResourceIndexPage from "./components/pages/resource-index-page";
import BlogIndexPage from "./components/pages/blog-index";
import EventsIndexPage from "./components/pages/events-index";
import RecentCoveragePage from "./components/pages/recent-coverage-page";
import PartnerListingPage from "./components/pages/partner-listing-page";
import CustomerSuccessIndexPage from "./components/pages/customer-success-index";
// init page components
SearchPage();
ResourceIndexPage();
BlogIndexPage();
EventsIndexPage();
RecentCoveragePage();
PartnerListingPage();
CustomerSuccessIndexPage();
